export * from './categories';
export * from './pins';
export * from './registry';
export * from './blocks';
export * from './codegen/cpp';
export * from './ai/snapshot';
export * from './ai/tools';
export * from './flash-errors';

import { registerAllBlocks } from './blocks';

// Importing the package registers every block exactly once.
registerAllBlocks();
